import {
  classes,
  getFilteredCountRatio,
  HorizontalFlexContainer,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Link } from 'react-router-dom';

import {
  boldLineageItemClass,
  LineageContentInfoItemBarRow,
  lineageContentInfoItemClass,
  LineageContentInfoItemLabelRow,
  SingleLineageItemContainer,
} from '../style/LineageCartoucheStyles';
import { SmallInlineFadeInSpinner } from '../widgets/SmallInlineFadeInSpinner';
import { LineageFilteredBar } from './LineageFilteredBar';
import { LineageIconButton } from './LineageIconButton';
import { LineageItemProps } from './LineageItemProps';


export function SingleLineageItem(props: LineageItemProps): JSX.Element {
  return (
    <SingleLineageItemContainer>
      <HorizontalFlexContainer>
        <LineageIconButton
          isCurrentPane={props.isCurrentPane}
          linkHref={props.linkHref}
          lineageItemType={props.lineageItemType}
          buttonAltText={props.buttonAltText}
        />
        <Link to={props.linkHref} className={lineageContentInfoItemClass}>
          <LineageContentInfoItemLabelRow>
            <span className={classes(props.isCurrentPane && boldLineageItemClass)} title={props.label}>
              {props.label}
            </span>
            {props.countLoading ? <SmallInlineFadeInSpinner /> : null}
          </LineageContentInfoItemLabelRow>
          <LineageContentInfoItemBarRow>
            <span className={classes(props.isCurrentPane && boldLineageItemClass)}>
              {props.filteredCount != null ? getFilteredCountRatio(props.filteredCount, props.unfilteredCount) : props.unfilteredCount}
            </span>
          </LineageContentInfoItemBarRow>
          <LineageContentInfoItemBarRow>
            <LineageFilteredBar filteredCount={props.filteredCount} unfilteredCount={props.unfilteredCount} />
          </LineageContentInfoItemBarRow>
        </Link>
      </HorizontalFlexContainer>
    </SingleLineageItemContainer>
  );
}

